/**
 * Transforms raw event participants into the format expected by Timeline component
 * @param {Array} participants - Raw event participants
 * @returns {Array} - Transformed participants with proper format
 */
export function transformParticipants(participants = []) {
	if (!participants || !participants.length) {
		return [];
	}

	return participants.map(e => {
		let name = 'unknown';
		if (e.participatable?.club) {
			if (e.participatable.club.code) name = e.participatable.club.code;
			else if (e.participatable.club.name) name = e.participatable.club.name;
		}
		if (e.context === 'player') {
			const words = e.participatable.name.match(/\b(\w+)\b/g);
			const capitalizedWords = words.filter(word => word.length > 0 && word[0] === word[0].toUpperCase());
			const abbreviation = capitalizedWords.map(word => word[0]);
			name = `${abbreviation.slice(0, 3).join('.')}.`;
		}

		return {
			id:       e.participatable.id,
			name,
			original: e,
		};
	});
}
